import script from "./slider-with-reset.vue?vue&type=script&setup=true&lang=js"
export * from "./slider-with-reset.vue?vue&type=script&setup=true&lang=js"

import "./slider-with-reset.vue?vue&type=style&index=0&id=be65176e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be65176e"]])

export default __exports__